// todo move this file to module
export let sendSmsAfterTwoStepLogin = {
    '1': 'ارسال شود',
    '0': 'ارسال نشود',
}